module.exports = "https://static.wmbcdn.com/uniweb/images/985dc745f0b44cb04b155c11e7ac74e8.svg";